import CollectionEmbed from '@/components/ui/CollectionEmbed';
import type { CollectionGridSection as CollectionGridSectionType } from '@shared/lib/page-sections/types';

export default function CollectionGridSection({ section }: { section: CollectionGridSectionType }) {
  if (!section.collectionId) {
    return null;
  }

  return (
    <section className="w-full px-4 py-10 md:py-14">
      <div className="mx-auto max-w-7xl">
        <CollectionEmbed
          collectionId={section.collectionId}
          displayType={section.displayType ?? 'GRID'}
          productLimit={section.productLimit ?? 12}
          title={section.title ?? null}
          showTitle={section.showTitle !== false}
        />
      </div>
    </section>
  );
}
